var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _ellipse, _circle3, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSshTunnelOpened = function SvgSshTunnelOpened(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 120,
    viewBox: "0 0 349 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 349,
    height: 117,
    transform: "translate(0 3)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.168 43.6494C198.168 30.7058 187.675 20.2129 174.731 20.2129C161.788 20.2129 151.295 30.7058 151.295 43.6494V78.7098C151.295 81.2943 153.39 83.3895 155.975 83.3895H193.488C196.073 83.3895 198.168 81.2944 198.168 78.7098V43.6494Z",
    fill: "url(#paint0_linear_3048_301330)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.053 48.2152C192.053 37.8964 183.688 29.5312 173.369 29.5312C163.05 29.5312 154.685 37.8964 154.685 48.2152V76.166C154.685 78.2264 156.355 79.8968 158.416 79.8968H188.322C190.382 79.8968 192.053 78.2264 192.053 76.166V48.2152Z",
    fill: "url(#paint1_linear_3048_301330)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.319 53.2837C183.319 45.5137 177.02 39.2148 169.25 39.2148C161.48 39.2148 155.182 45.5137 155.182 53.2837V74.3304C155.182 75.8819 156.439 77.1397 157.991 77.1397H180.51C182.062 77.1397 183.319 75.882 183.319 74.3304V53.2837Z",
    fill: "url(#paint2_linear_3048_301330)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.304 60.9263C174.304 55.6459 170.023 51.3652 164.743 51.3652C159.462 51.3652 155.182 55.6459 155.182 60.9263V75.2294C155.182 76.2838 156.036 77.1385 157.091 77.1385H172.395C173.449 77.1385 174.304 76.2838 174.304 75.2294V60.9263Z",
    fill: "url(#paint3_linear_3048_301330)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.04,
    cx: 197.5,
    cy: 25.5,
    r: 25.5,
    fill: "#00BFA5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.11,
    cx: 197.5,
    cy: 25.5,
    r: 18.5,
    fill: "#00BFA5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.563,
    cy: 98.9964,
    rx: 23.4365,
    ry: 3.05693,
    fill: "#EDEDED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 25.5,
    r: 11.625,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 12.584C190.383 12.584 184.583 18.3836 184.583 25.5007C184.583 32.6177 190.383 38.4173 197.5 38.4173C204.617 38.4173 210.416 32.6177 210.416 25.5007C210.416 18.3836 204.617 12.584 197.5 12.584ZM203.674 22.5298L196.35 29.8536C196.169 30.0344 195.924 30.1377 195.666 30.1377C195.407 30.1377 195.162 30.0344 194.981 29.8536L191.326 26.1982C190.951 25.8236 190.951 25.2036 191.326 24.829C191.7 24.4544 192.32 24.4544 192.695 24.829L195.666 27.7998L202.305 21.1607C202.679 20.7861 203.299 20.7861 203.674 21.1607C204.048 21.5352 204.048 22.1423 203.674 22.5298Z",
    fill: "#00BFA5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3048_301330",
    x1: 210.396,
    y1: 33.4596,
    x2: 166.58,
    y2: 52.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3048_301330",
    x1: 201.801,
    y1: 40.0918,
    x2: 166.87,
    y2: 55.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3048_301330",
    x1: 190.66,
    y1: 47.1668,
    x2: 164.357,
    y2: 58.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3048_301330",
    x1: 179.292,
    y1: 56.7693,
    x2: 161.417,
    y2: 64.6676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021549"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSshTunnelOpened);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ssh-tunnel-opened.af35bc27f4b29c9a9b618cb256ff3fd9.svg";